import { useEffect, useState } from "react";

import { HandWaveRegularV6 } from "@shared/v2/Icomoon";
import { tryCatchHandlr } from "@shared/Utilities";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";

const personAPI = (uuid, param) => `/api/v4/activity_feed/person_name?${param}=${uuid}`;

const GabbiAgentNeededActivity = ({ activity, onReadChange }) => {
  const [notableName, setNotableName] = useState(null);

  useEffect(() => {
    (async () => {
      const [resNotableName, errNotableName] = await tryCatchHandlr(
        caseTransformingAxios.get(`${personAPI(activity.data.personUuid, "person_uuid")}`),
      );

      if (errNotableName) throw errNotableName;

      setNotableName(resNotableName.data.name);
    })();
  }, [activity]);

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#ECE6FA] tw-text-[#572BAD]" Icon={HandWaveRegularV6}>
            Gabbi Needs an Agent
          </CategoryContainer>
        }
        personName={notableName === null ? "" : notableName || "No Name"}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <span className={`${STYLES.lineClamp3} tw-px-8px`}>{activity.data.conversationSummary}</span>
    </ActivityContainer>
  );
};

export default GabbiAgentNeededActivity;

GabbiAgentNeededActivity.propTypes = {
  ...activityCommonPropTypes,
};

GabbiAgentNeededActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
